<template>
    <div class="m-3">
        <h2 class="font-bold mb-3">Додано до кошика</h2>

        <div v-if="backLink" class="mb-5">
            <Link :href="backLink" @click="removeToast">
                <PrimaryButton color="white" hover-color="white" text-color="black">
                    До категорії {{ categoryTitle }}
                </PrimaryButton>
            </Link>
        </div>

        <div @click="openCart">
            <PrimaryButton>
                Перейти до кошика
            </PrimaryButton>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import PrimaryButton from "@/Components/PrimaryButton.vue";
import {Link} from "@inertiajs/vue3";
import {clearToasts} from 'mosha-vue-toastify';

export default defineComponent({
    components: {PrimaryButton, Link},
    props: {
        backLink: String,
        categoryTitle: String,
        cartEvent: Function,
    },
    methods: {
        openCart () {
            this.cartEvent()

            this.removeToast()
        },
        removeToast() {
            clearToasts()
        }
    }
})
</script>
